import { TableDescriptions } from "@interfaces/table-interface";
import { DragInDropHideOrderColumsTableComponent } from "components/dragDrop/drag-in-drop-hide-order-colums-table-component";
import { useState } from "react";
import { Modal, Row, Col, Form, Card, Button } from "react-bootstrap";

interface PropsModalOrderHideColumns {
  showModalColumns: boolean;
  closeColumn: (() => void) | undefined;
  applyAction: (newColumns: TableDescriptions[]) => Promise<void> | void;
  totalPageSize: number
  updateTotalPageSize: React.Dispatch<React.SetStateAction<number>>
  columns: any[]
  updateColumns: React.Dispatch<React.SetStateAction<TableDescriptions[]>>
  minPageSize?: number
  maxPageSize?: number
}

export const ModalOrderHideColumns: React.FC<PropsModalOrderHideColumns> = ({ showModalColumns, closeColumn, applyAction, totalPageSize, updateTotalPageSize, columns, updateColumns, minPageSize, maxPageSize }) => {
  const [validationMessage, setValidationMessage] = useState<string | null>(null);
  const [orderColumns, setOrderColumns] = useState<TableDescriptions[]>(columns);

  function getOutOfRangeMessage(value: number) {
    const hasMin = typeof minPageSize === 'number';
    const hasMax = typeof maxPageSize === 'number';
    if (Number.isNaN(value)) return 'Informe um número válido.';
    if (hasMin && hasMax) return `O valor deve estar entre ${minPageSize} e ${maxPageSize}.`;
    if (hasMin) return `O valor deve ser maior ou igual a ${minPageSize}.`;
    if (hasMax) return `O valor deve ser menor ou igual a ${maxPageSize}.`;
    return null;
  }

  function resetOrder() {
    let newOrder = orderColumns.sort((a, b) => (a.id > b.id ? 1 : -1))
    setOrderColumns(newOrder.map((value) => {
      value.order = value.id
      return value
    }))
  }

  async function applyChanges() {
    await applyAction(orderColumns);
  }

  return (
    <Modal show={showModalColumns} onHide={closeColumn} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Reordenar</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col className="mb-2">
            <Form.Group as={Row}>
              <Form.Label column>Quantidade de Item na Tabela:</Form.Label>
              <Col sm="12" md={4}>
                <Form.Control
                  type="number"
                  inputMode="numeric"
                  step={1}
                  min={minPageSize}
                  max={maxPageSize}
                  defaultValue={totalPageSize}
                  isInvalid={!!validationMessage}
                  onChange={(e) => {
                    const parsed = parseInt(e.target.value);
                    const hasMin = typeof minPageSize === 'number';
                    const hasMax = typeof maxPageSize === 'number';
                    if (Number.isNaN(parsed)) {
                      setValidationMessage('Informe um número válido.');
                      return;
                    }
                    if ((hasMin && parsed < (minPageSize as number)) || (hasMax && parsed > (maxPageSize as number))) {
                      setValidationMessage(getOutOfRangeMessage(parsed));
                    } else {
                      setValidationMessage(null);
                    }
                  }}
                  onBlur={(e) => {
                    e.preventDefault();
                    const parsed = parseInt(e.target.value);
                    const hasMin = typeof minPageSize === 'number';
                    const hasMax = typeof maxPageSize === 'number';
                    let nextValue = isNaN(parsed) ? totalPageSize : parsed;
                    if (hasMin && nextValue < (minPageSize as number)) nextValue = minPageSize as number;
                    if (hasMax && nextValue > (maxPageSize as number)) nextValue = maxPageSize as number;
                    updateTotalPageSize(nextValue);
                    if (Number.isNaN(parsed) || parsed !== nextValue) {
                      setValidationMessage(getOutOfRangeMessage(parsed));
                    } else {
                      setValidationMessage(null);
                    }
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  {validationMessage}
                </Form.Control.Feedback>
              </Col>
            </Form.Group>
          </Col>
        </Row>
        <Card>
          <Card.Body>
            <p className="mb-0 text-center">
              <small>Clique no item deixando-o em azul para que apareça na tabela, </small>
            </p>
            <p className="mt-0 text-center">
              <small>clique e segure no item para arrastá-lo e reordenar as colunas da tabela trocando os itens de lugar </small>
            </p>
            <DragInDropHideOrderColumsTableComponent columns={orderColumns} updateColumns={setOrderColumns} />
          </Card.Body>
        </Card>
      </Modal.Body>
      <Modal.Footer>
        <Button
          size="sm"
          variant="danger"
          onClick={resetOrder}>
          Resetar Ordem
        </Button>
        <Button
          size="sm"
          variant="primary"
          onClick={applyChanges}>
          Aplicar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}